
























// Copyright © 2021 Move Closer

import { defineComponent, SetupContext } from '@vue/composition-api'

import { DashmixIcon, DashmixIconName } from '../Icon'

import { DashmixButtonProps } from './Button.contract'
import { dashmixButtonProps, useDashmixButton } from './Button.hooks'

/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const DashmixButton = defineComponent({
  name: 'DashmixButton',
  components: { DashmixIcon },
  props: dashmixButtonProps,
  emits: ['click'],

  setup (props: DashmixButtonProps, ctx: SetupContext) {
    return { ...useDashmixButton(props, ctx), DashmixIconName }
  }
})

export default DashmixButton
